export default __webpack_public_path__ + "static/media/thumbnail2.309c5dde.jpg";